
const IndustriesHero = () => {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6fcf4f8e7722eab98c9ca1e35bd754bf.jpg"
          alt="Industries"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-zinc-950"></div>
      </div>

      {/* X Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="xPatternInd" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <line x1="0" y1="0" x2="100" y2="100" stroke="#10B981" strokeWidth="1" />
              <line x1="100" y1="0" x2="0" y2="100" stroke="#10B981" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#xPatternInd)" />
        </svg>
      </div>

      {/* Floating X Elements */}
      <div className="absolute top-1/4 left-10 text-emerald-500/10 text-[150px] font-bold">✕</div>
      <div className="absolute bottom-1/4 right-10 text-teal-500/10 text-[120px] font-bold rotate-45">✕</div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        <div className="mb-6">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full text-emerald-400 text-xs font-semibold uppercase tracking-widest">
            PRECISION DEPLOYMENT
          </span>
        </div>
        
        <h1 className="text-5xl lg:text-7xl font-extrabold text-white leading-tight">
          Industries Where <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Precision</span> Matters Most
        </h1>
      </div>
    </section>
  );
};

export default IndustriesHero;
